import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { DefaultTheme } from "styled-components/native";
import { getpriceModeTypes } from "@components/common/types";
import Routes from "@navigations/Routes";

const getPriceMode = ({
  background,
  textColor,
  focusedRouteName,
  user,
  theme,
}: getpriceModeTypes) => {
  const hiddenPriceModeRoutes = [Routes.Authentication, Routes.Splash];

  let priceColor: string;

  switch (user?.price_mode) {
    case PriceModes.GREEN:
      priceColor = theme["success-01"];
      break;
    case PriceModes.ORANGE:
      priceColor = theme["warn-01"];
      break;
    default:
      priceColor = theme["core-04"];
      break;
  }
  if (
    user?.id &&
    !user?.is_price_mode_lock &&
    user.price_mode !== PriceModes.WHITE &&
    (focusedRouteName
      ? !hiddenPriceModeRoutes.includes(focusedRouteName as Routes)
      : true)
  )
    return {
      headerTintColor: textColor
        ? theme[textColor as keyof DefaultTheme]
        : "core-05",
      contentStyle: {
        borderTopColor: priceColor,
        backgroundColor: theme["core-02"],
        // borderTopWidth: 4,
      },
      headerStyle: {
        borderBottomColor: priceColor,
        borderBottomWidth: 4,
        backgroundColor: background
          ? theme[background as keyof DefaultTheme]
          : "core-03",
      },
    };
  else
    return {
      headerTintColor: textColor
        ? theme[textColor as keyof DefaultTheme]
        : "core-05",
      contentStyle: {
        borderTopColor: theme["core-04"],
        backgroundColor: theme["core-02"],
      },
      headerStyle: {
        borderBottomColor: theme["core-04"],
        borderBottomWidth: 1,
        backgroundColor: background
          ? theme[background as keyof DefaultTheme]
          : "core-03",
      },
    };
};

export default getPriceMode;
